import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

// TODO: properly type return of get configuration
export const ConfigurationResource = {
  getConfiguration: async () => {
    const response = await AffinyEndpoint.Configuration.get().json();

    return response.data;
  },
};
